<div class="p-grid" *ngIf="aplicacoes">
  <div class="p-col-3">
    <div class="p-grid">
      <div class="p-col-8"><span>Atualizar lista automaticamente? </span></div>
      <div class="p-col-4"><p-inputSwitch [(ngModel)]="atualizacaoAutomatica" class="switch-p"></p-inputSwitch></div>
    </div>
    <div *ngFor="let aplicacao of aplicacoes" class="card-aplicacao">
      <div class="p-grid">
        <div class="p-col-8"><span class="titulo">{{aplicacao.aplicacao}}</span>&nbsp;<i *ngIf="aplicacao.contemMultiProjetos" class="warn pi pi-exclamation-triangle" pTooltip="O POD possui mais de um serviço implantado"></i></div>
        <div class="p-col-4">
          <p *ngIf="aplicacao?.pods?.length > 1" (click)="reiniciarAplicacao(aplicacao)" style="cursor: pointer; text-align: right" pTooltip="Reiniciar todos os Pods da aplicação">
            <i class="pi pi-refresh"></i></p>
        </div>
        <div class="p-col-10" *ngIf="aplicacao?.pods?.length > 0">
          <p *ngIf="!temMultiplasImagens(aplicacao)">
            {{aplicacao?.pods[0].containers[0].imagem}}
          </p>
          <p style="font-size: small;" *ngIf="temMultiplasImagens(aplicacao)">
            A aplicação possui pods com imagens de versões diferentes (caso tenha atualizado a versão recentemente aguarde alguns minutos para a atualização ser concluída)
          </p>
        </div>
        <div class="p-col-2 right buttons">
          <i class="pi pi-file-edit" pTooltip="Atualizar Versão" (click)="modalAtualizarVersao(aplicacao)"></i>
        </div>
      </div>
      <div>
        <div *ngIf="!aplicacao.error">
          <div class="p-grid" *ngFor="let pod of aplicacao.pods; index as i">
            <div class="p-col-10">
                <span class="status border" [ngClass]="getClasseStatus(pod.fase)">
                  <em class="pi" [ngClass]="getClasseIcon(pod.fase)"></em>
                  <!-- {{pod.fase}} -->
                </span>
              <span>&nbsp;</span>
              <span>{{pod.nome}}</span>
            </div>
            <div class="p-col-2 p-fluid">
              <i class="pi pie-file" pTooltip="Visualizar LOG do POD"
                 (click)="carregarLog(aplicacao.aplicacao, pod)"></i>&nbsp;&nbsp;
              <i class="pi pi-refresh" pTooltip="Reiniciar do POD" (click)="dialogReiniciarPod(pod, aplicacao)"></i>
            </div>
            <div *ngFor="let container of pod.containers">
              <div class="card-container">
                <span>
                  <span *ngIf="container.situacaoDescricao" class="status" [ngClass]="getClasseStatus(pod.fase)"
                        style="font-weight: bold">
                    {{container.situacaoDescricao}} -
                  </span>
                  Qtd. Reinicio: {{container.quantidadeRestart}}
                  - Idade: {{container.iniciadoEm | amLocale:'pt-br' | amTimeAgo}}
                </span>
              </div>
              <div *ngIf="temMultiplasImagens(aplicacao)" class="card-container">
                <span class="label">Imagem: </span><span>{{container.imagem}}</span>
              </div>
            </div>
            <hr *ngIf="i < aplicacao.pods.length - 1"/>
          </div>
        </div>
      </div>
      <div *ngIf="aplicacao.error">
        <div class="p-text-break" style="word-wrap: break-word;">{{aplicacao.error}}</div>
      </div>
    </div>

  </div>
  <div class="p-col-9" *ngIf="podSelecionado && mostrarLogs">
    <div class="p-grid">
      <div class="p-col-8">
        <span><b>{{podSelecionado.nome}}</b>&nbsp;</span>
        <p-dropdown [options]="podSelecionado.containers" [(ngModel)]="containerSelecionado" optionLabel="nome"
                    optionValue="nome" (onChange)="onChangeContainer($event)"></p-dropdown>
      </div>
      <div class="p-col-4 buttons right">
        <i class="pi pi-refresh" (click)="reiniciarPodSelecionado()" pTooltip="Reiniciar do POD"></i>
        <i class="pi pi-download" (click)="downloadLogPodSelecionado()" pTooltip="Download log completo do POD"></i>
      </div>
      <div class="p-col-12" style="max-height: 70vh; overflow: scroll;">
        <pre  class="p-text-break">{{logPod}}</pre>
      </div>
    </div>
  </div>
  <p-dialog modal="true" header="Atualizar versão da aplicação" [style]="{width: '450px'}" [(visible)]="modalAtualizarVersaoVisivel" *ngIf="aplicacaoSelecionada">
    <div class="p-fluid">
      <div class="p-grid card-aplicacao">
        <div class="p-col-3 right"><span class="label">Nome: </span></div>
        <div class="p-col-9"><span>{{aplicacaoSelecionada.aplicacao}}</span></div>
        <div class="p-col-3 right"><span class="label">Nº Pods: </span></div>
        <div class="p-col-9"><span>{{aplicacaoSelecionada.pods.length}}</span></div>
        <div class="p-col-3 right"><span class="label">Imagem: </span></div>
        <div class="p-col-9"><span>{{aplicacaoSelecionada.pods[0].containers[0].imagem}}</span></div>
        <div class="p-col-3 right"><span class="label">Versão Atual: </span></div>
        <div class="p-col-9"><span>{{versaoAtual}}</span></div>
        <div class="p-col-3 right"><span class="label">Última Versão: </span></div>
        <div class="p-col-9"><input type="text" pInputText [(ngModel)]="versaoAtualizacao"/></div>
        <div class="p-col-12"><span class="label">PODs:</span></div>
        <div class="p-col-12" *ngFor="let pod of aplicacaoSelecionada.pods">
          <div>
                <span class="status" [ngClass]="getClasseStatus(pod.fase)">
                  <em class="pi" [ngClass]="getClasseIcon(pod.fase)"></em> {{pod.fase}}</span>
            <span>&nbsp;</span>
            <span>{{pod.nome}}</span>
          </div>
          <div *ngFor="let container of pod.containers">
            <div class="card-container">
              <span>Qtd. Reinicio: {{container.quantidadeRestart}} - Idade: {{container.iniciadoEm | amLocale:'pt-br' | amTimeAgo}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="p-col-12">
        <button pButton type="button" icon="pi pi-refresh" (click)="atualizarVersao()" label="Atualizar"
                class="p-button-info" style="float: right"></button>
      </div>
    </div>
  </p-dialog>
</div>
<div class="p-fluid" *ngIf="!aplicacoes" style="padding: 20px;">
  <div class="p-col-12">
    <p *ngIf="atualizacaoAutomatica">Buscando as informações das aplicações. Tentativa {{tentativasPosErro}} de {{maxTentativasPosErro}}</p>
  </div>
  <div class="p-col-12">
    <p-message *ngIf="tentativasPosErro >= maxTentativasPosErro" severity="warn"
               text="Não foi possível carregar as informações de infraestrutura, favor verificar se os serviços de integração com o kubernetes estão configurados corretamente">
    </p-message>
  </div>
  <div class="p-col-12">
    <p-message severity="error" [text]="msgErro" *ngIf="msgErro"></p-message>
  </div>
</div>
<p-dialog  modal="true" header="Atenção" [(visible)]="modalReiniciarPod" [style]="{width: '20vw'}">
  <p><i class="pi pi-exclamation-triangle p-button-danger "></i>Tem certeza que deseja reiniciar do <span class="p-text-bold">POD?</span></p>
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Sim" (click)="reiniciarPod()"  icon="pi pi-check p-text-bold" class="p-button-raised p-button-sm"></button>
    <button pButton type="button" label="Não" (click)="modalReiniciarPod=false" icon="pi pi-times" class="p-button-secondary p-button-sm"></button>
  </ng-template>
</p-dialog>
